import { render, staticRenderFns } from "./TableCountry.vue?vue&type=template&id=35adcd95"
import script from "./TableCountry.vue?vue&type=script&lang=ts"
export * from "./TableCountry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports